import React, { useRef, useState } from "react";
import PageHeading from "../../../components/PageHeading";
import Button from "../../../components/btn/Button";
import { HiOutlineArrowRight } from "react-icons/hi";
import RowTxt from "../../../components/RowTxt";
import { motion } from "framer-motion";
import Modal from "../../../components/modal/Modal";
import { useSelector } from "react-redux";
import PageLoading from "../../../components/PageLoading";
import store from "../../../redux/store";

import { DeleteIcon } from "../../../utils/utils";
import moment from "moment";
import Table from "../../../components/table/Table";
import {
  AddButton,
  BackButton,
  HelpButton,
} from "../../../components/btn/Buttons";
import { domestic_cylinder_sales_API, email_invoice_api } from "../../../utils/apis";
import { toast } from "react-toastify";
import SmallModal from "../../../components/modal/SmallModal";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";

import { Pagination3 } from "../../../components/pagination/pagination";
import NoData from "../../../components/NoData";
import { get_domestic_sales_list } from "../trasactionsSlice";
import ReactToPrint from "react-to-print";
import { UnitFunction } from "../../../utils/validation";
import SearchApiHook from "../../../CustomHooks/SearchApiHook";

import { ReduceFunction } from "../../../utils/Hook/ReduceFunction";
import TaxInvoice3 from "../../../components/TaxInvoice/TaxInvoice3";
import AddDomestic from "../../../components/AddComponent/AddDomestic";
import { MdOutlineMail } from "react-icons/md";
import Tooltip from "../../../components/tooltip/Tooltip";
import { generatePdfFromElement } from "../../../utils/pdfGenerator";

export const DomestiCylSale = () => {
  const previewRef = useRef(null);

  const [isAdd, setIsAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailItem, setEmailItem] = useState({});
  const [mess, setMess] = useState("");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [viewItem, setViewItem] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState("5");
  const [totalCount, setTotalCount] = useState("");
  const [prevSearch, setPrevSearch] = useState("");
  const [SearchCount, setSearchCount] = useState(0);
  const [SerchInput, setSearchInput] = useState("");

  const { user_id, emp_id, user_type } = useSelector((state) => state.other);

  const navigate = useNavigate();
  const { domestic_sales_list, domestic_sales_loading } = useSelector(
    (state) => state.transactions
  );

  const obj = {
    page: pageNo,
    limit: entries,
    setTotalCount: setTotalCount,
    setSearchCount: setSearchCount,
    search: SerchInput,
  };
  const fetchData = () => {
    store.dispatch(get_domestic_sales_list(obj));
    console.log(domestic_sales_list, "check")

  };
  SearchApiHook(fetchData, SerchInput?.trim(), prevSearch, [entries, pageNo]);

  const onDelete_item = async () => {
    try {
      setOpen(false);
      setLoading(true);
      const body = new FormData();
      body.append("action", "delete");
      body.append("agencyid", user_id);
      body.append("id", id);
      if (emp_id) {
        body.append("emp_code", emp_id);
      }
      const deletedBy = emp_id ? emp_id : user_id;
      body.append("deleted_by", deletedBy);

      const responce = await domestic_cylinder_sales_API(body);
      setLoading(false);
      if (responce.success) {
        const newPageNo = domestic_sales_list?.length < 2 ? pageNo - 1 : pageNo;
        setPageNo(newPageNo);
        store.dispatch(
          get_domestic_sales_list({
            page: newPageNo,
            limit: entries,
            setTotalCount,
            setSearchCount,
            search: SerchInput,
          })
        );
        toast.success(responce.message);
      } else if (!responce.success) {
        setMess(responce.message);
        setOpen1(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generateInvoicePdfBlob = async () => {
    if (!previewRef.current) return null;
    return await generatePdfFromElement(previewRef.current);
  };

  const handleSendEmail = async (item) => {
    try {
      setOpenEmailModal(false);
      setLoading(true);

      setViewItem(item);
      await new Promise((resolve) => setTimeout(resolve, 400));

      if (!previewRef.current) {
        setLoading(false);
        toast.error("Invoice template is not ready");
        return;
      }

      const pdfBlob = await generateInvoicePdfBlob();
      if (!pdfBlob) {
        setLoading(false);
        toast.error("Failed to generate PDF attachment");
        return;
      }

      const invoiceNumber = item?.SR_NO || item?.INVOICE_NO || "";
      const email = item?.CVO_EMAIL || item?.EMAIL || "";

      const body = new FormData();
      body.append("action", "email");
      body.append("module", "dom");
      body.append("invoice_number", invoiceNumber);
      body.append("email", email);
      body.append("attachment", pdfBlob, `${invoiceNumber || "invoice"}.pdf`);

      const res = await email_invoice_api(body);
      setLoading(false);

      if (res?.success) {
        toast.success(res?.message || "Email sent successfully!");
      } else {
        setOpen1(true);
        setMess(res?.message || "Failed to send email");
      }
    } catch (error) {
      setLoading(false);
      console.log("Email error:", error);
      toast.error("Something went wrong while sending email");
    }
  };


  return (
    <div className="container">
      <PageHeading
        title={"DOMESTIC CYLINDER SALES"}
        right={
          <>
            <AddButton
              onClick={() => {
                setIsAdd(true);
              }}
            />
            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/WMuWtnlI8zc",
                "https://youtu.be/l8xqCNiWcQw",
              ]}
            />
          </>
        }
      />
      <Pagination3
        totalCount={Math.min(totalCount, SearchCount)}
        SerchInput={SerchInput}
        serchChange={(e) => {
          const input = e.target.value;
          setSearchInput(input);
          setPrevSearch(SerchInput);
          setPageNo(1);
        }}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      >
        {domestic_sales_loading ? (
          <PageLoading />
        ) : domestic_sales_list?.length == 0 ? (
          <NoData />
        ) : (
          <div className="grid">
            {domestic_sales_list?.map((v, i) => (
              <div className="card" key={i}>
                <div>
                  <div className="card-heading">
                    {v?.cvo_name || "CASH SALES / HOUSEHOLDS"}
                  </div>

                  <RowTxt
                    title="Invoice No."
                    value={
                      <ReactToPrint
                        trigger={() => (
                          <div
                            onMouseEnter={() => setViewItem(v)}
                            onTouchStart={() => setViewItem(v)}
                            onClick={() => setViewItem(v)}
                            style={{ cursor: "pointer" }}
                          >
                            {v?.SR_NO}
                          </div>
                        )}
                        content={() => previewRef.current}
                        documentTitle={`${v?.cvo_name || "CASH SALES / HOUSEHOLDS"
                          }-${v?.SR_NO}`}
                      />
                    }
                  />

                  <RowTxt
                    title="Invoice Date"
                    value={moment(v?.SI_DATE).format("DD-MMM-YYYY")}
                  />
                  <RowTxt title="Total Amount" value={v?.SI_AMOUNT} />

                  <RowTxt
                    title="Payment Terms"
                    value={
                      {
                        1: "Cash",
                        2: "Credit",
                      }[v?.PAYMENT_TERMS] || ""
                    }
                  />

                  <RowTxt title="Godown Address" value={v?.GODOWN_NAME} />

                  {v?.PAYMENT_TERMS == "1" && (
                    <>
                      <RowTxt title="Cash Received" value={v?.CASH_AMOUNT} />
                      <RowTxt
                        title="Online Received"
                        value={v?.AMOUNT_RECEIVED_ONLINE}
                      />
                      <RowTxt
                        title="Transaction ID"
                        value={v?.TRANSACTION_ID || "NA"}
                      />
                      <RowTxt
                        title="Cash Received From"
                        value={
                          {
                            1: "Phone Pay",
                            2: "Google Pay",
                            3: "Paytm",
                            4: "Cred",
                            5: "Others",
                          }[v?.RECEIVED_FROM] || "NA"
                        }
                      />
                      <RowTxt title="Bank Account" value={v?.BANK_ACC_NO} />
                    </>
                  )}

                  <RowTxt
                    title="Prepaid Amount"
                    value={
                      v?.products
                        .map((v) => v?.AMOUNT_RCVD_ONLINE)
                        .reduce((a, b) => Number(a) + Number(b), 0)
                        ?.toFixed(2) || "-"
                    }
                  />
                  
                  <RowTxt
                    title="Prepaid Bank Amount"
                    value={
                      v?.products?.length
                        ? v.products.map(item => item?.BANK_ACC_NO).join(", ")
                        : "-"
                    }
                  />

                  <RowTxt title="Created By" value={v?.CREATED_NAME || "-"} />
                </div>

                <div
                  className="df jcsb mt10"
                  style={{
                    justifyContent:
                      user_type != "admin" && v?.EMPLOYEE_CODE != emp_id
                        ? "flex-end"
                        : "space-between",
                  }}
                >
                  {v?.STATUS_FLAG == 0 &&
                    (user_type == "admin" || v?.EMPLOYEE_CODE == emp_id) && (
                      <DeleteIcon
                        onClick={() => {
                          setId(v?.ID);
                          setOpen(true);
                        }}
                      />
                    )}

                  {(v?.CVO_EMAIL || v?.EMAIL) && (v?.CVO_EMAIL || v?.EMAIL)?.trim() !== "" && (
                    <Tooltip content={`Send Email (${v?.CVO_EMAIL || v?.EMAIL})`}>
                      <MdOutlineMail
                        onClick={() => {
                          setViewItem(v);
                          setEmailItem(v);
                          setOpenEmailModal(true);
                        }}
                        color="#007bff"
                        size={22}
                        cursor={"pointer"}
                      />
                    </Tooltip>
                  )}

                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 1.05 }}
                    className="flex aic gap10 jce cursor-pointer"
                    onClick={() => {
                      setOpenView(true);
                      setViewItem(v);
                    }}
                  >
                    <div className="view-btn">View</div>
                    <HiOutlineArrowRight size={20} color="#1b64af" />
                  </motion.div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Pagination3>

      {isAdd && (
        <AddDomestic
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          setMess={setMess}
          setOpen1={setOpen1}
          setLoading={setLoading}
          obj={obj}
          mess={mess}
        />
      )}

      {openView && (
        <Modal
          header_right={
            <div className="flex gap10">
              {(viewItem?.CVO_EMAIL || viewItem?.EMAIL) && (viewItem?.CVO_EMAIL || viewItem?.EMAIL)?.trim() !== "" && (
                <Button
                  style={{ cursor: "pointer" }}
                  title={"SEND EMAIL"}
                  onClick={() => {
                    setEmailItem(viewItem);
                    setOpenEmailModal(true);
                  }}
                />
              )}
              <ReactToPrint
                trigger={() => (
                  <Button style={{ cursor: "pointer" }} title={"PRINT"} />
                )}
                content={() => previewRef.current}
                documentTitle={`${viewItem?.cvo_name || "CASH SALES / HOUSEHOLDS"
                  }-${viewItem?.SR_NO}`}
              />
            </div>
          }
          onCancel={() => {
            setViewItem({});
          }}
          isOpen={openView}
          title={"DOMESTIC CYLINDER SALES"}
          setIsOpen={setOpenView}
          body={
            <>
              {viewItem?.DC_NO && (
                <div
                  style={{
                    display: "flex",
                    gap: "2rem",
                  }}
                >
                  <div>DC Number : {viewItem?.DC_NO}</div>
                  <div>
                    DC Date : {moment(viewItem?.DC_DATE).format("DD/MM/YYYY")}
                  </div>
                </div>
              )}
              <Table
                mt={10}
                headData={[
                  "PRODUCT",
                  "DELIVERED BY	",
                  "AREA CODE",
                  "GST%",
                  "UNIT PRICE",
                  "DISCOUNT ON UNIT PRICE",
                  "QUANTITY",
                  "PREPAID CYLINDERS",
                  "PSV QUANTITY",
                  "TRANSPORT CHARGES",
                  "TRANSACTION AMOUNT",
                  "TOTAL AMOUNT",
                  // "ONLINE RCVD AMOUNT",
                ]}
                body={
                  <>
                    {viewItem?.products?.map((v, i) => (
                      <tr key={i}>
                        <td>{v?.CAT_NAME + "-" + v?.CAT_DESC}</td>
                        <td>{v?.EMP_NAME || "NA"}</td>
                        <td>{v?.AREA_CODE || "NA"}</td>
                        <td>{v?.GSTP}</td>
                        <td>{Number(v?.UNIT_RATE).toFixed(2)}</td>
                        <td>{Number(v?.DISC_UNIT_RATE).toFixed(2)}</td>
                        <td>{v?.QUANTITY}</td>
                        <td>{v?.PRE_CYLS}</td>
                        <td>{v?.PSV_CYLS}</td>
                        <td>{Number(v?.TRANSPORT_CHARGES).toFixed(2)}</td>
                        <td>{Number(v?.SALE_AMOUNT).toFixed(2)}</td>
                        <td>{Number(v?.TOTAL_AMOUNT).toFixed(2)}</td>
                        {/* <td>{Number(v?.AMOUNT_RCVD_ONLINE).toFixed(2)}</td> */}
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={7} />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        TOTAL
                      </td>
                      <td />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.TRANSPORT_CHARGES)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.SALE_AMOUNT)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.TOTAL_AMOUNT)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td>
                      {/* <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.AMOUNT_RCVD_ONLINE)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td> */}
                    </tr>
                  </>
                }
              />
            </>
          }
        />
      )}

      <div
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "850px",
          background: "#fff",
        }}
      >
        <TaxInvoice3
          empty_row_height={180 - (viewItem?.products?.length || 0) * 25}
          previewRef={previewRef}
          listdata={{
            SR_NO: viewItem?.SR_NO,
            SR_NO_DATE: viewItem?.SI_DATE,
            CVO_NAME: viewItem?.cvo_name
              ? viewItem?.cvo_name
              : "CASH SALES / HOUSEHOLDS",
            CVO_ADDRESS: viewItem?.CVO_ADDRESS,
            CVO_DISTRICT: viewItem?.B_DISTRICT,
            CVO_LOCATION: viewItem?.B_LOCATION,
            B_STATE_CODE: viewItem?.B_STATE,
            B_STATE_NAME: viewItem?.B_STATE_NAME,
            CVO_PINCODE: viewItem?.PINCODE,
            CVO_TIN:
              viewItem?.CVO_TIN ||
              (viewItem?.CUST_GSTIN == "0" ? "" : viewItem?.CUST_GSTIN) ||
              "NA",
            EMAIL: viewItem?.CVO_EMAIL,
            MOBILE: viewItem?.CVO_CONTACT,
            SHIP_CVO_NAME: viewItem?.cvo_name
              ? viewItem?.cvo_name
              : "CASH SALES / HOUSEHOLDS",
            SHIP_CVO_ADDRESS: viewItem?.S_ADDRESS,
            SHIP_CVO_DISTRICT: viewItem?.S_DISTRICT,
            SHIP_CVO_LOCATION: viewItem?.S_LOCATION,
            SHIP_B_STATE: viewItem?.S_STATE,
            SHIP_B_STATE_NAME: viewItem?.S_STATE_NAME,
            SHIP_CVO_PINCODE: viewItem?.S_PINCODE,
            SHIP_CVO_TIN:
              viewItem?.CVO_TIN ||
              (viewItem?.CUST_GSTIN == "0" ? "" : viewItem?.CUST_GSTIN) ||
              "NA",
            dc_num: viewItem?.DC_NO,
            dc_num_date: viewItem?.DC_DATE,
          }}
          table_body={
            <>
              {viewItem?.products?.map((v, i) => (
                <tr key={i}>
                  <td className="both">{i + 1}</td>
                  <td
                    className="both"
                    style={{
                      textAlign: "left",
                      fontWeight: "bold",
                      fontSize: "12px",
                      minWidth: "250px",
                    }}
                  >
                    {/* {`${v?.CAT_NAME} - ${v?.CAT_DESC} `} */}
                    DOM-LPG-{v?.CAT_DESC}
                  </td>
                  <td className="both">{v?.HSNCODE}</td>
                  <td className="both">
                    {Number(v?.QUANTITY) - Number(v?.PSV_CYLS)}{" "}
                    {UnitFunction(v?.UNITS || v?.UOM, "title")}
                  </td>
                  <td className="both">{Number(v?.UNIT_RATE).toFixed(2)}</td>
                  <td className="both">{v?.DISC_UNIT_RATE}</td>
                  <td className="both">{v?.GSTP} %</td>
                  <td className="both" style={{ textAlign: "right" }}>
                    {(
                      (Number(v?.QUANTITY) - Number(v?.PSV_CYLS)) *
                      (Number(v?.UNIT_RATE) - Number(v?.DISC_UNIT_RATE))
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </>
          }
          taxable_amt={ReduceFunction(viewItem?.invoice, "TAXABLE_AMOUNT")}
          Total_tax={ReduceFunction(viewItem?.hsn_groups, "TOTAL_AMOUNT")}
          igst={ReduceFunction(viewItem?.invoice, "IGST_AMOUNT")}
          cgst={ReduceFunction(viewItem?.invoice, "CGST_AMOUNT")}
          sgst={ReduceFunction(viewItem?.invoice, "SGST_AMOUNT")}
          other={(
            Number(ReduceFunction(viewItem?.invoice, "TRANSPORT_CHARGES")) +
            (Number(ReduceFunction(viewItem?.invoice, "TRANSPORT_CHARGES")) *
              5) /
            100
          ).toFixed(2)}
          net_total={Number(viewItem?.SI_AMOUNT).toFixed(2)}
        />
      </div>

      {open && (
        <SmallModal
          title={"Confirm"}
          isOpen={open}
          setIsOpen={setOpen}
          mess={"Are you sure? You want to delete"}
          onClick={() => onDelete_item()}
        />
      )}
      {openEmailModal && (
        <SmallModal
          title={"Confirm Send Email"}
          bname={"SEND"}
          cname={"CANCEL"}
          isOpen={openEmailModal}
          setIsOpen={setOpenEmailModal}
          mess={`Are you sure you want to send invoice (${emailItem?.SR_NO}) to ${emailItem?.CVO_EMAIL || emailItem?.EMAIL}?`}
          onClick={() => handleSendEmail(emailItem)}
        />
      )}
      {open1 && (
        <SmallModal
          title={"Alerts"}
          isOpen={open1}
          setIsOpen={setOpen1}
          mess={mess}
          okbtn={true}
        />
      )}
      {loading && <Loader />}
    </div>
  );
};
